import React from 'react';
import ComponentWrapper from '../../../components/layout/ComponentWrapper';
import { StudyDesignOverview, StudyDesignArms, StudyCopyBlock } from '../index';
import { QsubWYSIWYG } from '../../../util/typography/WYSIWYG';
import FadeAnimation from '../../Animations/FadeAnimation';
import styled from 'styled-components';

const StyledQsubWYSIWYG = styled(QsubWYSIWYG)`
ul > li {
    font-size: 18px;
    line-height: 24px;
    font-weight: 300;

    strong {
        font-weight: 500;
        }
    }
`;
const QsubstudyArm = styled.div`
.text-nowrap{
    white-space: nowrap;
     }
`;

const QsubStudyDesign = () => (
    
    <ComponentWrapper>
        <FadeAnimation dontAnimate={false} showOnce={true} thresholdIntersection={0.3} animationDirection='BottomToTop' >
                <StudyDesignOverview
            
            data={[
                [
                    {
                        title: 'Participants',
                        description: `
                            <p>Patients with previously untreated mNSCLC with no <i>EGFR</i>, <i>ALK</i>, or <i>ROS1</i> genomic tumor aberrations</p>
                            <p>Patients were excluded if they had autoimmune disease that required systemic therapy within 2 years of treatment, had a medical condition that required immunosuppression, or had received >30 Gy of thoracic radiation within the prior 26 weeks</p>

                        `,
                        type: 'box-white',
                        colspan: 2
                    }
                ],
                [
                    {
                        type: 'arrow-purple',
                        colspan: 2
                    }
                ],
                [
                    {
                        title: 'Randomized<sup>e</sup> 2:1 (N=377)',
                        type: 'box-white',
                        colspan: 2
                    }
                ],
            ]}
        />
        </FadeAnimation>
        <FadeAnimation dontAnimate={false} showOnce={true} thresholdIntersection={0.3} >
            <QsubstudyArm>
        <StudyDesignArms title="Study Arms" arms={[
                {
                title: "KEYTRUDA QLEX",
                    data: [
                        [
                            {
                                title: 'SC (n=251)',
                                description: `
                                    <p><strong>Nonsquamous NSCLC:</strong> 790 mg pembrolizumab and 9,600 units berahyaluronidase alfa SC Q6W + pemetrexed and platinum chemotherapy (cisplatin or carboplatin) IV Q3W for 4 cycles, followed by pemetrexed IV Q3W<sup>f</sup></p>
                                    <p><strong>Squamous NSCLC:</strong> 790 mg pembrolizumab and 9,600 units berahyaluronidase alfa SC Q6W + carboplatin and a taxane (paclitaxel or paclitaxel protein-bound) IV Q3W for 4 cycles<sup>g</sup></p>
                                `,
                                type: 'box-purple-white'
                            }
                        ],
                        [
                            {
                                type: 'arrow-purple'
                            }
                        ],
                        [
                            {
                                description: '<p>Treatment with KEYTRUDA QLEX continued until RECIST v1.1-defined progression of disease as determined by the investigator, unacceptable toxicity, or a maximum of 18 cycles (approximately 24 months)<sup>h</sup></p>',
                                type: 'box-white'
                                
                            }
                        ]
                    ]
                },
                {
                title: "KEYTRUDA",
                    data: [
                        [
                            {
                                title: 'IV (n=126)',
                                description: `
                                <p><strong>Nonsquamous NSCLC:</strong> <br />Pembrolizumab 400 mg IV Q6W + pemetrexed and platinum chemotherapy (cisplatin or carboplatin) IV Q3W for 4 cycles, followed by pemetrexed IV Q3W<sup>f</sup></p>
                                <p><strong>Squamous NSCLC:</strong> <br />Pembrolizumab 400 mg IV Q6W + carboplatin + a taxane (paclitaxel or paclitaxel <span class="text-nowrap">protein-bound</span>) IV Q3W for 4 cycles<sup>g</sup></p>
                                `,
                                type: 'box-green-white'
                            }
                        ],
                        [
                            {
                                type: 'arrow-green'
                            }
                        ],
                        [
                            {
                                description: '<p>Treatment with KEYTRUDA continued until RECIST v1.1-defined progression of disease as determined by the investigator, unacceptable toxicity, or a maximum of 18 cycles (approximately 24 months)<sup>h</sup></p>',
                                type: 'box-white'
                            }
                        ]
                    ]
                }
        ]} 
    />
    </QsubstudyArm>
    </FadeAnimation>

    <StyledQsubWYSIWYG>
        <QsubWYSIWYG>
            <ul>
                <li><strong>Primary Outcome Measure:</strong> Pembrolizumab exposure (cycle 1 AUC<sub>0-6wks</sub> and cycle 3 [ie, steady state] C<sub>trough</sub>) of KEYTRUDA QLEX as compared to KEYTRUDA</li>
                <li><strong>Additional Descriptive Efficacy Outcome Measures:</strong> overall response rate (ORR) by Blinded Independent Central Review (BICR), progression-free survival (PFS) by BICR, and overall survival (OS)</li>
            </ul>
        </QsubWYSIWYG>
    </StyledQsubWYSIWYG>
</ComponentWrapper>
);

export default QsubStudyDesign;
